import Page from '../base/Page';
import 'slick-carousel';
import 'mediaelement';

export default class ProductPage extends Page {
    init() {
        //this.slickinit();
        this.rangestyle();
        this.showRange();
        this.onsize();
    }

    rangestyle() {
        var heights = $(".range-content").map(function () {
                return $(this).height();
            }).get(),

            maxHeight = Math.max.apply(null, heights);
        $(".slider-for").css("height", maxHeight);

    }

    onsize() {
        $(window).resize(function () {
            var heights = $(".range-content").map(function () {
                    return $(this).height();
                }).get(),

                maxHeight = Math.max.apply(null, heights);
            $(".slider-for").css("height", maxHeight);
        });

    }

    showRange() {
        $(".range-title").click(function () {
            var order = $(this).attr('data-order');
            $(".range-title").removeClass('active');
            $('.range-title-' + order).addClass('active');
            $(".range-content").hide();
            $(".range-content.content-" + order).fadeToggle('slow');
        });
    }

    slickinit() {
        //var len = $(".range-title").length;

        /*$('.slider-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            asNavFor: '.slider-nav'
        });
        $('.slider-nav').slick({
            slidesToShow: len,
            slidesToScroll: 1,
            asNavFor: '.slider-for',
            dots: true,
            focusOnSelect: true
        });*/



    }


}



// WEBPACK FOOTER //
// ./src/js/pages/ProductPage.js